const sData = {
  organization_name: 'infobae.com',
  last_update: '25-05-2022T10:00Z',
  election: {
    title: 'Presidente Colombia 2022 Mayo',
    key: 'infobae.com:colombia:all:segunda-vuelta:president:2022',
    type: 'Segunda Vuelta',
    charge: 'Presidente',
    charge_type: 'president',
    region: {
      country: 'Colombia',
      state: 'All',
      state_code: 'CO',
      city: '',
    },
    tables: {
      available_voters: 0,
      qty: 0,
      percent: 0,
    },
    total_votes: {
      qty: 0,
      percent: 0,
    },
  },
  parties: [
    {
      votes: 0,
      votes_percent: 0,
      party_id: '1',
      name: 'Liga de Gobernantes Anticorrupción',
      candidates: [
        {
          candidate_id: 'Presidente',
          fullname: 'Rodolfo Hernández',
          votes: 0,
          votes_percent: 0,
          block_name: 'Liga de Gobernantes Anticorrupción',
          avatar: 'https://statics-ecp.infobae.com/2022/colombia/primer-vuelta/img/avatars/rodolfo-hernandez.png',
        },
        {
          candidate_id: 'Vicepresidente',
          fullname: 'Marelen Castillo',
          votes: 0,
          votes_percent: 0,
          block_name: 'Liga de Gobernantes Anticorrupción',
          avatar: 'https://statics-ecp.infobae.com/2022/colombia/primer-vuelta/img/avatars/marelen-castillo.png',
        },
      ],
      block: 'Liga de Gobernantes Anticorrupción',
      settings: {
        color: '#F9AC29',
      },
      election_key: 'infobae.com:colombia:all:primer-vuelta:president:2022',
    },
    {
      votes: 0,
      votes_percent: 0,
      party_id: '6',
      name: 'Pacto Histórico',
      candidates: [
        {
          candidate_id: 'Vicepresidente',
          fullname: 'Francia Márquez',
          votes: 0,
          votes_percent: 0,
          block_name: 'Pacto Histórico',
          avatar: 'https://statics-ecp.infobae.com/2022/colombia/primer-vuelta/img/avatars/francia-marquez.png',
        },
        {
          candidate_id: 'Presidente',
          fullname: 'Gustavo Petro',
          votes: 0,
          votes_percent: 0,
          block_name: 'Pacto Histórico',
          avatar: 'https://statics-ecp.infobae.com/2022/colombia/primer-vuelta/img/avatars/gustavo-petro.png',
        },
      ],
      block: 'Pacto Histórico',
      settings: {
        color: '#540088',
      },
      election_key: 'infobae.com:colombia:all:primer-vuelta:president:2022',
    },
  
  ],
  stats: [
    {
      name: 'VOTOS EN BLANCO',
      type: 'blank',
      votes: 0,
      votes_percent: 0,
      settings: {
        color: '#FFFFFF',
        class: 'bar-as-rect',
      },
    },
    {
      name: 'Votos Impugnados',
      type: 'contested',
      votes: 0,
      votes_percent: 0,
      settings: {
        color: '#FFFFFF',
        class: 'bar-as-rect',
      },
    },
    {
      name: 'Votos Nulos',
      type: 'annulled',
      votes: 0,
      votes_percent: 0,
      settings: {
        color: '#FFFFFF',
        class: 'bar-as-rect',
      },
    },
  ],
};

export default sData;
